export default __webpack_public_path__ + "img/reward_2-1-8b9f24b4.png";